'use client';

import type { ReactNode } from 'react';
import {
  HeadingItem,
  SettingsCard,
  SettingsSection,
} from '@terra/ui-design-system';

type ProxySettingsGroupProps = {
  title?: string;
  description?: string;
  tooltip?: string;
  action?: ReactNode;
  children: ReactNode;
};

export function ProxySettingsGroup({
  title,
  description,
  tooltip,
  action,
  children,
}: ProxySettingsGroupProps) {
  if (!title) {
    return <SettingsCard>{children}</SettingsCard>;
  }

  return (
    <SettingsSection
      title={<HeadingItem>{title}</HeadingItem>}
      description={description}
      tooltip={tooltip}
      action={action}
    >
      <SettingsCard>{children}</SettingsCard>
    </SettingsSection>
  );
}
